<template>
  <div>
    <TextModal
      v-if="showableModal"
      :title-text="'メッセージを送信しました'"
      :caption-text="'次は届いたギフトを確認しましょう'"
      :primary-button-text="'確認する'"
      :cancel-button-text="'閉じる'"
      @clicked-modal-cover="closeModal"
      @clicked-primary="clickedPrimary"
      @clicked-cancel="closeModal"
    />
  </div>
</template>

<script>
import TextModal from '../../molecules/modals/text-modal'

export default {
  components: { TextModal },
  data() {
    return {
      showableModal: false
    }
  },
  mounted() {
    this.showModal()
  },
  methods: {
    showModal() {
      this.showableModal = true
    },
    closeModal() {
      this.showableModal = false
    },
    clickedPrimary() {
      // TODO:チケット券面へのリンクへ飛ぶよう修正
      this.closeModal()
    }
  }
}
</script>
